import { RibbonScalingStep } from '@1js/acui-ribbon-like';
import { dropLabel, moveToOverflowWell } from 'owa-command-ribbon';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { TabScalingAndLayoutConfig } from 'owa-mail-ribbon-store-shared-types';
import { LabelPreferenceId } from 'owa-mail-ribbon-store-shared-types';
import { MailRibbonControlId } from 'owa-ribbon-ids';
import { modifyIdsForCompose } from './modifyIdsForCompose';
import { computedFn } from 'mobx-utils/lib/computedFn';

/**
 * Retrieves the initial scaling steps for a given tab.
 * @param tab what the store has saved as the tab configuration
 * @param controlsWithoutLabels the controls that should never have labels
 * @returns a series of RibbonScalingStep that represent the order in which the initial scaling
 * should occur
 */
export const getInitialScalingSteps = computedFn(
    (
        tab: TabScalingAndLayoutConfig,
        controlsWithoutLabels: RibbonControlId[],
        viewState: ComposeViewState | undefined
    ): RibbonScalingStep[] => {
        let initialScalingSteps: RibbonScalingStep[] = [];

        initialScalingSteps.push(moveToOverflowWell(MailRibbonControlId.RibbonCustomizer));
        initialScalingSteps.push(
            moveToOverflowWell(...modifyIdsForCompose(tab.controlsInOverflow, viewState))
        );

        if (controlsWithoutLabels) {
            initialScalingSteps.push(
                dropLabel(...modifyIdsForCompose(controlsWithoutLabels, viewState))
            );
        }

        /**
         * Default is all labels - except the labels listed above - are shown,
         * unless the user set the label preference to be never show
         */
        if (tab.showLabelsPreference === LabelPreferenceId.NeverShow) {
            let allControlsInRibbon: RibbonControlId[] = [];

            tab.layout.forEach(
                group => (allControlsInRibbon = allControlsInRibbon.concat(...group.controlIds))
            );
            initialScalingSteps.push(
                dropLabel(...modifyIdsForCompose(allControlsInRibbon, viewState))
            );
        }

        return initialScalingSteps;
    }
);
